import "@Styles/Shared/Youtube/videoWatchButton_sm.less";
import { PLAY_VIDEO_EVENT } from './_constants';

var initializeWatchButton = function initializeWatchButton(config, elementId) {
  var element = document.getElementById(elementId);
  var button = element ? element.querySelector(".videoWatchButton") : null;

  if (button && config && config.videoId) {
    button.onclick = function () {
      var event = new CustomEvent(PLAY_VIDEO_EVENT, {
        detail: config.videoId
      });
      document.dispatchEvent(event);
    };
  }
};

export default (function (config, elementId) {
  return initializeWatchButton(config, elementId);
});